import React from 'react';
import PropTypes from 'prop-types';
import { View} from 'react-native';
import { pure } from '@dbk/ui-react-utils';
import Text,{ Small, Large } from '../text';
import Calendar, { CalendarSelectedDate } from '../calendar';
import BlurModal from '../blur-modal';
import Flexheight from '../flex-height';
import subMonths from 'date-fns/sub_months';
import addMonths from 'date-fns/add_months';
function CalendarModal(props) {
  const {
    modal: {
      visible,
      onDone,
    },
    calendar: {
      selectingDate,
      onSelectingDateChanged,
      fromDate,
      toDate,
      minDate,
      maxDate,
      onSelectDate,
    },
    thisYearOnly,
    backDate,
    numberOfPastMonth,
    numberOfFutureMonth,
    // config
    animationType,
    scrollOnce,

    // texts & labels
    doneLabel,
    title,
    monthNames,
    weekdayNames,

    // data
    highlightDays,
  } = props;




  function renderCalender()
  {
    let todayDate,previousDate,nextDate;
    todayDate=new Date();

    if(numberOfPastMonth){
       previousDate = subMonths(todayDate,numberOfPastMonth);
       nextDate = todayDate;

    }
    if(numberOfFutureMonth){
      previousDate=todayDate;
      nextDate=addMonths(todayDate,numberOfFutureMonth);
    }
      return(

        <Calendar
          fromDate={fromDate}
          toDate={toDate}
          minDate={previousDate}
          maxDate={nextDate}
          monthNames={monthNames}
          weekdayNames={weekdayNames}
          highlightDays={highlightDays}
          onSelectDate={onSelectDate}
          messages={props.messages}
          languageCode={props.languageCode}
        />
      );
  }

  return (

    <BlurModal
      visible={visible}
      animationType={animationType}
      doneLabel={props.messages['app.calendar.doneBtn']}
      title={props.messages['app.calendar.selectdate']}
      onDone={onDone}
    >
        <div>
          <div className="calendar-modal-wrapper">
            <CalendarSelectedDate
              fromDate={fromDate}
              toDate={toDate}
              selectingDate={selectingDate}
              onChange={onSelectingDateChanged}
              messages={props.messages}
            />
          </div>
          <Flexheight ratio={0.7} scrollOnce={scrollOnce}>
            <div className="calendar-modal-wrapper">
              {renderCalender()}
            </div>
          </Flexheight>
        </div>

    </BlurModal>


  );




}

CalendarModal.propTypes = {
  modal: PropTypes.shape({
    visible: BlurModal.propTypes.visible,
    onDone: BlurModal.propTypes.onDone,
  }),
  calendar: PropTypes.shape({
    selectingDate: CalendarSelectedDate.propTypes.selectingDate,
    onSelectingDateChanged: CalendarSelectedDate.propTypes.onChange,
    fromDate: CalendarSelectedDate.propTypes.fromDate,
    toDate: CalendarSelectedDate.propTypes.toDate,
    minDate: Calendar.propTypes.minDate,
    maxDate: Calendar.propTypes.maxDate,
    onSelectDate: Calendar.propTypes.onSelectDate,
  }),

  // config
  animationType: PropTypes.func,
  scrollOnce: PropTypes.bool,

  // texts & labels
  monthNames: Calendar.propTypes.monthNames,
  weekdayNames: Calendar.propTypes.weekdayNames,
  doneLabel: BlurModal.propTypes.doneLabel,
  title: BlurModal.propTypes.title,

  // data
  highlightDays: Calendar.propTypes.highlightDays,
};

CalendarModal.defaultProps = {
  title: 'Select date range',
  modal: {},
  calendar: {},
};

export default pure(CalendarModal);
